import styles from '../styles/dialogue.module.css';
import Layout from '../components/Layout';
import layoutConfig from 'components/DashboardNew/layoutConfig';
import GridRenderer from 'components/DashboardNew/GridRenderer';

const DashboardNewWindow = () => {
    return (
        <Layout hasDashboardFilter>
            <div className={styles.newDialog}>
                <GridRenderer config={layoutConfig} />
            </div>
        </Layout>
    );
}

export default DashboardNewWindow;


